var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileDocx(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.705,
    rx: 4,
    transform: "translate(.063 .148)",
    fill: "#185ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.446 21.349c.047.356.078.666.093.931h.054c.021-.251.063-.554.125-.91.061-.355.121-.655.18-.9L14.422 10h3.264l2.612 10.314c.13.51.24 1.157.326 1.945h.044a14.4 14.4 0 0 1 .272-1.883L23.03 10H26l-3.656 15h-3.472l-2.491-9.938a21.75 21.75 0 0 1-.245-1.119c-.091-.46-.147-.794-.169-1.004h-.043c-.03.244-.085.607-.169 1.088-.084.481-.15.836-.201 1.067L13.214 25H9.69L6 10h3.024L11.3 20.492c.051.215.1.502.147.857L16 12.647",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDocx);
export default __webpack_public_path__ + "static/media/file-docx.216b12af.svg";
export { ForwardRef as ReactComponent };